import styled from '@emotion/styled'
import type { FC, PropsWithChildren } from 'react'

import ImageComponent from '@segment/matcha/components/Image'

interface ImageProps {
  images: {
    png: string
    png2x: string
    webp: string
    webp2x: string
  }
  alt: string
  size?: readonly [number, number]
}

export const Image: FC<PropsWithChildren<ImageProps>> = ({ images, alt, size = [240, 240] }) => {
  const [w, h] = size
  return (
    <ImageWrapper>
      <picture>
        <source type="image/webp" srcSet={`${images.webp}, ${images.webp2x} 2x`} />
        <ImageComponent width={w} height={h} src={images.png2x} alt={alt} loading="lazy" />
      </picture>
    </ImageWrapper>
  )
}

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`
